/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import persistReducer from "redux-persist/es/persistReducer";
import storage from "redux-persist/es/storage";

interface TwoFAState {
	enabled: "Y" | "N";
}

const initialState: TwoFAState = {
	enabled: "N",
};

const twoFAStateSlice = createSlice({
	name: "twoFAState",
	initialState,
	reducers: {
		setTwoFAEnabled(state, action: PayloadAction<"Y" | "N">) {
			state.enabled = action.payload;
		},
		resetTwoFA() {
			return initialState;
		},
	},
});

// Persist configuration for the 2FA slice
const twoFAPersistConfig = {
	key: "twoFAState",
	storage,
	// blacklist: ["enabled"],
};

// Persisted reducer for the 2FA slice
export const twoFAPersistentReducer = persistReducer(twoFAPersistConfig, twoFAStateSlice.reducer);

export const { setTwoFAEnabled, resetTwoFA } = twoFAStateSlice.actions;
